import styled from "styled-components";

type ListEntryIconProps = {
    dense?: boolean
    end?: boolean
}

const ListEntryIcon = styled.div<ListEntryIconProps>`
    ${ props => props.end ?
        `margin-left: ${props.dense ? props.theme.spacing(1) : props.theme.spacing(2)};` :
        `margin-right: ${props.dense ? props.theme.spacing(1) : props.theme.spacing(2)};`
    }
    color: ${ props => props.theme.palette.text.secondary};
`;

export { ListEntryIcon, ListEntryIconProps };
export default ListEntryIcon;
